<template>
  <div>
    <div class="feedback-bar">
      <div class="feedback-container">
        <div class="header date">
          <h4>Tilbakemelding</h4>
          <h5>{{ feedback.date }}</h5>
        </div>
        <div class="feedback-text">
          <p v-for="(item, index) in feedback.text" v-bind:key="index">
            {{ item }}
          </p>
        </div>
        <div class="download-button">
          <font-awesome-icon icon="download" /> Download
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      feedback: { date: "eheheheje", text: ["nyehehehe", "emememem", "test"] },
    };
  },
};
</script>

<style scoped>
.feedback-container {
  display: flex;
  flex-direction: column;
  margin: auto;
  box-shadow: 0px 0px 7px 2px rgba(0, 0, 0, 0.46);
  padding: 10px;
}
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.download-button {
  margin: auto;
  margin-left: 0;
  padding: 10px;
  color: var(--primary-color);
}
.feedback-text {
  border-bottom: 1px solid var(--primary-border-color);
  border-top: 1px solid var(--primary-border-color);
}
</style>